export const SEO_BASE_URL = "https://bellhopt.com";

// Placeholder routes commented out until copy is ready
// Uncomment individual routes as pages are built
export const placeholderRoutes = [
  // "/for/otas",
  // "/integrations/guesty",
  // "/integrations/track",
  // "/integrations/lodgify",
  // "/integrations/hostaway",
  // "/integrations/hospitable",
  // "/integrations/manual-onboarding",
  // "/help",
  // "/help/airbnb-grocery-delivery-how-it-works",
  // "/help/airbnb-kitchen-stocking-vs-concierge-stocking",
  // "/help/what-is-grocery-stocking",
  // "/help/24-hour-lead-time-policy",
  // "/help/delivery-vs-stocking",
  // "/resources",
  // "/resources/booking-confirmation-email-template-pre-arrival-groceries",
  // "/resources/pm-launch-kit-guest-grocery-program",
  // "/resources/stocking-list-2-night-stay",
  // "/resources/stocking-list-4-night-stay",
  // "/resources/stocking-list-7-night-stay",
  // "/resources/reduce-guest-complaints-pre-arrival-groceries",
];

export const internalLinkTargets = [
  { label: "Pre-arrival groceries", to: "/pre-arrival-groceries" },
  { label: "Vacation rental grocery delivery", to: "/vacation-rental-grocery-delivery" },
  { label: "For property managers", to: "/for/property-managers" },
  { label: "Integrations", to: "/integrations" },
];

export const cityPages = [
  {
    city: "los-angeles",
    displayName: "Los Angeles",
    indexable: true,
    metaDescription:
      "Los Angeles Airbnb grocery delivery and pre-arrival grocery stocking by Bellhopt Concierge. Guests shop 20,000+ products, and we deliver, stock, and organize before check-in. 24-hour lead time required.",
    heroIntro:
      "Bellhopt Concierge gives Los Angeles short-term rentals a true pre-arrival grocery delivery and guest concierge layer. Guests shop 20,000+ products before check-in, then our team shops, delivers, stocks, and organizes the home so arrivals feel premium from the first hour.",
    marketWhy:
      "Los Angeles inventory spans high-rise units, beach neighborhoods, gated hillsides, and dense multifamily buildings. Reliable grocery stocking depends on accurate access notes, loading instructions, and timing around traffic-heavy check-in windows.",
    operationsNotes:
      "Expect gate codes, stacked multifamily check-ins, and strict loading windows in dense neighborhoods. Most arrivals cluster from late afternoon into the evening, so building access details and parking instructions are critical for consistent execution.",
    howItWorksNotes: [
      "Property managers connect the home, access flow, and arrival timing so Bellhopt can dispatch cleanly across Los Angeles neighborhoods.",
      "Guests place a pre-arrival grocery order from 20,000+ products instead of choosing from a thin essentials package.",
      "Bellhopt Concierge shops, delivers, stocks, and organizes the kitchen before check-in, then supports during-stay concierge services when the stay calls for more.",
    ],
    serviceHighlights: [
      "Pre-arrival grocery delivery that is stocked and organized, not left at the door",
      "During-stay concierge services for wellness, dining, celebration, and transportation requests",
      "Operational consistency for property managers running multiple Los Angeles short-term rentals",
    ],
    conciergeUseCases: [
      "Late check-in fridge stocking for flight-heavy arrival days",
      "Family breakfast setup for beach and city stays",
      "Celebration staging, restaurant coordination, and guest service support during the stay",
    ],
    arrivalBundle: [
      "Hydration kit for warm-weather arrivals with still water, sparkling water, fruit, and electrolytes",
      "Short-stay breakfast starter with eggs, yogurt, coffee, fruit, and bakery items",
      "Late check-in snack and coffee reset for guests landing after rush-hour traffic",
    ],
    localFaq: [
      {
        q: "How does Los Angeles Airbnb grocery delivery work with Bellhopt Concierge?",
        a: "Guests order ahead from 20,000+ products, then Bellhopt shops, delivers, stocks, and organizes the home before check-in. It is a pre-arrival grocery stocking service, not a door-drop handoff.",
      },
      {
        q: "Can Bellhopt handle access details for Los Angeles condos and multifamily buildings?",
        a: "Yes. We work from the host or property manager's access notes, including gate codes, loading rules, parking instructions, and elevator timing so the order reaches the unit correctly.",
      },
      {
        q: "Do you only offer groceries in Los Angeles, or also concierge services during the stay?",
        a: "Bellhopt also supports during-stay concierge services such as celebration setup, transport coordination, wellness requests, and other guest-facing service needs depending on the property and market.",
      },
      {
        q: "Is this useful for Los Angeles property managers with multiple listings?",
        a: "Yes. Bellhopt is built for repeatable execution across portfolios, so property managers can offer a stronger guest arrival standard without running grocery logistics themselves.",
      },
      {
        q: "What lead time is required for Los Angeles grocery stocking?",
        a: "A minimum 24-hour lead time is required so Bellhopt can shop accurately, dispatch reliably, and deliver an arrival-ready result.",
      },
    ],
  },
  {
    city: "san-diego",
    displayName: "San Diego",
    indexable: true,
    metaDescription:
      "San Diego Airbnb grocery delivery and vacation rental grocery stocking by Bellhopt Concierge. Guests shop 20,000+ products, and Bellhopt delivers, stocks, and organizes before arrival. 24-hour lead time required.",
    heroIntro:
      "Bellhopt Concierge helps San Diego vacation rentals offer pre-arrival grocery delivery that feels elevated, not transactional. Guests order exactly what they want from 20,000+ products, and Bellhopt stocks and organizes the home before they arrive.",
    marketWhy:
      "San Diego stays often mix coastal homes, detached entries, and lockbox-based access with weekend-heavy arrival demand. That makes timing, parking notes, and coastal-area routing essential for a clean guest handoff.",
    operationsNotes:
      "Beach-area properties often use lockboxes and detached entries with separate parking instructions. Weekend arrivals spike in coastal zones, so concierge teams need clear access timing, host notes, and a dependable cold-chain process.",
    howItWorksNotes: [
      "Hosts and property managers provide access details and turnover timing so Bellhopt can route each San Diego arrival correctly.",
      "Guests use a pre-arrival shopping flow to choose from 20,000+ products, from breakfast basics to full-stay grocery orders.",
      "Bellhopt shops, delivers, stocks, and organizes the kitchen, then stays available for higher-touch guest concierge support when needed.",
    ],
    serviceHighlights: [
      "Pre-arrival grocery stocking for beach homes, condos, and urban short-term rentals",
      "During-stay concierge services that complement premium coastal guest experiences",
      "A cleaner arrival process for San Diego operators who want consistency, not ad hoc grocery coordination",
    ],
    conciergeUseCases: [
      "Family coastal arrivals with fresh fruit, hydration, breakfast staples, and snack coverage",
      "Long-weekend kitchen resets for beach groups and extended families",
      "Restaurant, celebration, and wellness requests layered on top of grocery stocking",
    ],
    arrivalBundle: [
      "Family coastal arrival bundle with breakfast basics, fruit, snacks, and hydration",
      "Long-weekend produce and pantry starter for 3 to 5 night beach stays",
      "Kitchen-ready essentials with coffee, dairy, bakery, and ready-to-heat items",
    ],
    localFaq: [
      {
        q: "What makes San Diego pre-arrival grocery delivery different from standard delivery apps?",
        a: "Bellhopt does more than drop groceries at the door. We deliver, stock, and organize the home so the kitchen is ready when the guest walks in.",
      },
      {
        q: "Can Bellhopt support San Diego beach properties with separate access instructions?",
        a: "Yes. We work from property-specific notes such as lockboxes, detached entries, gate access, parking instructions, and timing windows that are common in coastal neighborhoods.",
      },
      {
        q: "Can guests order more than a preset package in San Diego?",
        a: "Yes. Bellhopt supports a real shopping experience with 20,000+ products, so guests can build the exact cart they want rather than picking from a limited preset.",
      },
      {
        q: "Does Bellhopt offer guest concierge services during San Diego stays?",
        a: "Yes. In addition to pre-arrival groceries, Bellhopt can support select during-stay concierge services such as transport, dining, celebration, and wellness coordination based on the market.",
      },
      {
        q: "What lead time is required for San Diego grocery stocking?",
        a: "Bellhopt requires at least 24 hours of lead time to protect execution quality and ensure the home is properly stocked before arrival.",
      },
    ],
  },
  {
    city: "miami",
    displayName: "Miami",
    indexable: true,
    metaDescription:
      "Miami Airbnb grocery delivery, pre-arrival grocery stocking, and concierge services by Bellhopt. Guests shop 20,000+ products, and Bellhopt delivers, stocks, and organizes before check-in. 24-hour lead time required.",
    heroIntro:
      "Bellhopt Concierge helps Miami short-term rentals deliver a sharper guest experience with pre-arrival groceries, stocked and organized before check-in. Guests can shop 20,000+ products, and operators can offer a premium arrival standard without adding operational drag.",
    marketWhy:
      "Miami arrivals often run through high-rise access, front-desk protocols, elevator constraints, and event-driven peaks. A strong grocery stocking workflow requires coordination that is built for condo operations, not casual delivery.",
    operationsNotes:
      "High-rise access and front desk procedures are common, often requiring advance guest or driver registration. Arrival cadence tends to bunch around check-in windows, weekend volume, and event-heavy dates.",
    howItWorksNotes: [
      "Property teams share condo access requirements, parking flow, and timing notes so Bellhopt can execute within building rules.",
      "Guests place a full pre-arrival grocery order from 20,000+ products instead of relying on a thin essentials list.",
      "Bellhopt Concierge handles the shop, delivery, stocking, and organization, then supports premium guest service requests as the stay unfolds.",
    ],
    serviceHighlights: [
      "Pre-arrival grocery delivery for Miami condos and vacation rentals",
      "During-stay concierge services that fit high-touch leisure and celebration travel",
      "A portfolio-ready operating layer for Miami property managers and host teams",
    ],
    conciergeUseCases: [
      "Hydration, breakfast, and fresh-fridge setups for warm-weather arrivals",
      "Extended-stay grocery stocking for condo travelers who want the kitchen fully ready",
      "Celebration, dining, transport, and lifestyle requests handled through Bellhopt Concierge",
    ],
    arrivalBundle: [
      "Tropical hydration bundle with water, sparkling water, citrus, and recovery snacks",
      "Extended-stay condo fridge starter with breakfast, produce, and coffee coverage",
      "Late-arrival comfort bundle with ready-to-eat items and next-morning essentials",
    ],
    localFaq: [
      {
        q: "How does Bellhopt handle Miami condo and front-desk access for grocery stocking?",
        a: "We work from the property's building instructions, including registration steps, doorman policies, elevator timing, and access windows so the order reaches the right unit correctly.",
      },
      {
        q: "Is Miami Airbnb grocery delivery with Bellhopt just a handoff at the lobby or door?",
        a: "No. Bellhopt is built around stocked-and-organized execution inside the home when access is provided, so guests arrive to a kitchen that feels ready to use.",
      },
      {
        q: "Can Miami guests order from a full grocery catalog?",
        a: "Yes. Guests shop from 20,000+ products, which makes Bellhopt a true pre-arrival shopping experience rather than a limited grocery package.",
      },
      {
        q: "Do you support during-stay concierge services in Miami?",
        a: "Yes. Bellhopt can support guest concierge services such as celebration setup, dining coordination, transport requests, and other premium stay enhancements alongside grocery stocking.",
      },
      {
        q: "What lead time is required for Miami grocery delivery and stocking?",
        a: "A minimum 24-hour lead time is required so Bellhopt can plan around building access, shopping, delivery, and organization standards.",
      },
    ],
  },
  {
    city: "orlando",
    displayName: "Orlando",
    indexable: true,
    metaDescription:
      "Orlando Airbnb grocery delivery and pre-arrival grocery stocking by Bellhopt Concierge. Guests shop 20,000+ products, and Bellhopt delivers, stocks, and organizes vacation rentals before arrival. 24-hour lead time required.",
    heroIntro:
      "Bellhopt Concierge helps Orlando vacation rentals deliver an arrival-ready kitchen before guests walk in. Families can shop 20,000+ products ahead of time, and Bellhopt handles the grocery run, delivery, stocking, and organization before check-in.",
    marketWhy:
      "Orlando demand is shaped by family travel, larger basket sizes, gate-controlled communities, and tightly timed check-ins around park schedules. Grocery stocking has to be accurate, scalable, and built for vacation-rental operations.",
    operationsNotes:
      "Vacation communities frequently have gate checkpoints and strict parking instructions. Family-heavy arrivals drive demand for kid-friendly staples, larger carts, and reliable timing around theme-park travel schedules.",
    howItWorksNotes: [
      "Property managers provide access flow, community rules, and turnover timing so Bellhopt can execute smoothly inside Orlando vacation communities.",
      "Guests order exactly what they want from 20,000+ products for a real pre-arrival grocery experience, not a basic package.",
      "Bellhopt shops, delivers, stocks, and organizes the home, then remains a concierge extension for guest needs that come up during the stay.",
    ],
    serviceHighlights: [
      "Large-cart grocery stocking for family and group arrivals",
      "During-stay concierge services that support vacation-heavy guest needs",
      "Less back-and-forth for Orlando property managers coordinating check-ins at scale",
    ],
    conciergeUseCases: [
      "Theme-park arrival recovery with hydration, breakfast, snacks, and easy meals",
      "Large-group pantry and fridge stocking for multi-bedroom homes",
      "Extra guest services during the stay, from celebration touches to logistics support",
    ],
    arrivalBundle: [
      "Theme-park recovery bundle with hydration, breakfast, and snack staples",
      "Family breakfast stock-up for multi-day trips with milk, eggs, fruit, cereal, and coffee",
      "Large-group pantry starter with snacks, drinks, sandwich items, and ready-to-heat meals",
    ],
    localFaq: [
      {
        q: "Why is Orlando pre-arrival grocery delivery valuable for vacation rentals?",
        a: "Orlando arrivals often involve families, kids, long travel days, and late check-ins. Bellhopt helps guests walk into a stocked kitchen instead of making a grocery run after arrival.",
      },
      {
        q: "Can Bellhopt handle gated Orlando vacation communities?",
        a: "Yes. We follow the community's entry process, parking rules, and property access notes so the grocery stocking run fits the arrival workflow.",
      },
      {
        q: "Can Orlando guests order more than essentials?",
        a: "Yes. Guests shop from 20,000+ products, which lets them order full-trip groceries, family staples, snacks, and specialty items rather than a small preset package.",
      },
      {
        q: "Do you offer more than groceries for Orlando guests?",
        a: "Yes. Bellhopt also supports during-stay concierge services in the market, giving property managers a stronger guest service layer beyond the pre-arrival grocery order.",
      },
      {
        q: "What lead time is required for Orlando grocery stocking?",
        a: "A 24-hour minimum lead time is required so Bellhopt can protect quality and execute reliably across busy community arrival windows.",
      },
    ],
  },
  {
    city: "phoenix",
    displayName: "Phoenix",
    indexable: true,
    metaDescription:
      "Phoenix Airbnb grocery delivery and grocery stocking service by Bellhopt Concierge. Guests shop 20,000+ products, and Bellhopt delivers, stocks, and organizes before arrival. 24-hour lead time required.",
    heroIntro:
      "Bellhopt Concierge helps Phoenix short-term rentals turn pre-arrival grocery delivery into a premium arrival standard. Guests choose from 20,000+ products, and Bellhopt handles the shopping, delivery, stocking, and organization before they arrive.",
    marketWhy:
      "Phoenix grocery stocking needs are shaped by suburban homes, long transfer times, and hot-weather handling. Strong execution depends on accurate access notes, efficient routing, and disciplined cold-chain protection.",
    operationsNotes:
      "Heat-sensitive runs require strong cold-chain handling and clear entry instructions for suburban homes. Arrival windows are often staggered due to flight timing, golf travel, and longer transfer distances.",
    howItWorksNotes: [
      "Property teams share access details, parking flow, and delivery timing so Bellhopt can route each Phoenix order without friction.",
      "Guests build a real grocery cart from 20,000+ products instead of choosing from generic welcome bundles.",
      "Bellhopt shops, delivers, stocks, and organizes the order before check-in and can extend the guest experience with concierge support during the stay.",
    ],
    serviceHighlights: [
      "Pre-arrival grocery stocking designed for desert-climate execution",
      "During-stay concierge services that support leisure, wellness, and group travel",
      "A cleaner operating model for Phoenix property managers who want consistency at scale",
    ],
    conciergeUseCases: [
      "Hydration-first arrival setups for warm-weather stays",
      "Protein, produce, and coffee stocking for golf, work, and wellness travelers",
      "Guest concierge support during the stay for celebration, transport, or lifestyle needs",
    ],
    arrivalBundle: [
      "Desert climate hydration bundle with water, sparkling water, fruit, and recovery staples",
      "Protein-forward short-stay kitchen set with eggs, yogurt, deli, produce, and coffee",
      "Two-night essentials bundle with breakfast, pantry items, and ready-to-heat options",
    ],
    localFaq: [
      {
        q: "How does Bellhopt manage Phoenix grocery stocking in hot-weather conditions?",
        a: "Bellhopt builds the run around timing, cold-chain protection, and direct execution into the home so groceries arrive and are stocked in a way that protects quality.",
      },
      {
        q: "Is Phoenix Airbnb grocery delivery with Bellhopt door-only delivery?",
        a: "No. Bellhopt is a stocked-and-organized service for short-term rentals when property access is provided.",
      },
      {
        q: "Can Phoenix guests order from a full grocery catalog before arrival?",
        a: "Yes. Guests shop from 20,000+ products, which supports full-trip grocery orders, not just a basic essentials list.",
      },
      {
        q: "Do Phoenix property managers use Bellhopt across multiple homes?",
        a: "Yes. Bellhopt is designed to work across portfolios so operators can standardize the guest arrival experience across Phoenix listings.",
      },
      {
        q: "What lead time is required for Phoenix pre-arrival groceries?",
        a: "At least 24 hours of lead time is required so Bellhopt can plan the order, execute the shop, and deliver a reliable stocked-and-organized result.",
      },
    ],
  },
  {
    city: "austin",
    displayName: "Austin",
    indexable: true,
    metaDescription:
      "Austin Airbnb grocery delivery and pre-arrival grocery stocking by Bellhopt Concierge. Guests shop 20,000+ products, and Bellhopt stocks and organizes vacation rentals before check-in. 24-hour lead time required.",
    heroIntro:
      "Bellhopt Concierge gives Austin hosts and property managers a stronger way to handle pre-arrival grocery delivery. Guests shop 20,000+ products ahead of time, and Bellhopt delivers, stocks, and organizes the home before the stay begins.",
    marketWhy:
      "Austin inventory blends downtown condos, residential homes, and event-driven travel that creates sharp arrival surges. That makes grocery stocking an operational system problem, not just a convenience add-on.",
    operationsNotes:
      "Mixed urban and residential inventory means varied parking and entry workflows. Event-driven demand creates concentrated check-in waves where standardized dispatch notes improve consistency.",
    howItWorksNotes: [
      "Hosts and managers provide property access details and timing notes so Bellhopt can execute reliably across Austin neighborhoods.",
      "Guests use a pre-arrival shopping flow with 20,000+ products to build the exact grocery order they want for the stay.",
      "Bellhopt Concierge completes the shop, delivery, stocking, and organization, then supports premium guest service requests during the stay when needed.",
    ],
    serviceHighlights: [
      "Pre-arrival grocery delivery designed for Austin vacation rentals and urban stays",
      "During-stay concierge services that support event travel, long weekends, and premium guest expectations",
      "Operational lift for Austin property managers who want better guest service without adding internal workload",
    ],
    conciergeUseCases: [
      "Weekend event arrivals with snacks, breakfast, hydration, and coffee already in place",
      "Remote-work and longer-stay setups with pantry, produce, and easy-meal coverage",
      "Guest concierge coordination for celebration, dining, and transport needs during the stay",
    ],
    arrivalBundle: [
      "Weekend event bundle with grab-and-go options, drinks, and late-arrival staples",
      "Remote-work stay starter with coffee, breakfast, snacks, and quick meals",
      "Balanced four-night essentials bundle with dairy, produce, bakery, and pantry basics",
    ],
    localFaq: [
      {
        q: "What does Austin Airbnb grocery delivery with Bellhopt actually include?",
        a: "Bellhopt shops, delivers, stocks, and organizes the order inside the home before check-in. It is designed to leave the property arrival-ready rather than simply supplied.",
      },
      {
        q: "Can Austin guests build their own grocery order?",
        a: "Yes. Guests can shop from 20,000+ products, so the order can match anything from a short business stay to a long weekend with a larger group.",
      },
      {
        q: "Does Bellhopt support Austin property managers with multiple listings?",
        a: "Yes. Bellhopt is built for portfolio operations and helps property managers standardize a premium guest arrival across Austin inventory.",
      },
      {
        q: "Are concierge services available during Austin stays too?",
        a: "Yes. Bellhopt can support guest concierge services in addition to pre-arrival groceries, including requests tied to dining, wellness, celebration, and transportation.",
      },
      {
        q: "What lead time is required for Austin grocery stocking?",
        a: "A minimum 24-hour lead time is required so Bellhopt can shop accurately, route correctly, and stock the home before arrival.",
      },
    ],
  },
  {
    city: "nashville",
    displayName: "Nashville",
    indexable: true,
    metaDescription:
      "Nashville Airbnb grocery delivery, grocery stocking, and concierge services by Bellhopt. Guests shop 20,000+ products, and Bellhopt delivers, stocks, and organizes before arrival. 24-hour lead time required.",
    heroIntro:
      "Bellhopt Concierge helps Nashville short-term rentals create a more polished first impression with pre-arrival grocery delivery that is stocked and organized before guests arrive. Guests shop from 20,000+ products, and operators get a consistent guest-service layer they can trust.",
    marketWhy:
      "Nashville arrivals are often compressed into short-stay, high-turnover weekends where timing, elevator access, and building logistics matter as much as the grocery cart itself. A repeatable process is what protects the guest experience.",
    operationsNotes:
      "High turnover in short downtown stays requires fast, repeatable stocking workflows. Building access and elevator logistics often matter as much as route planning, especially on weekend arrival waves.",
    howItWorksNotes: [
      "Property managers share access, parking, and timing details so Bellhopt can dispatch efficiently through Nashville's dense turnover windows.",
      "Guests place a true pre-arrival grocery order from 20,000+ products rather than relying on a limited package or host-managed list.",
      "Bellhopt handles shopping, delivery, stocking, and organization before check-in, with concierge support available during the stay for additional guest needs.",
    ],
    serviceHighlights: [
      "Pre-arrival grocery delivery for downtown stays, group trips, and short-turn arrivals",
      "During-stay concierge services that match Nashville's celebration-heavy travel patterns",
      "A more repeatable service standard for Nashville property managers and operations teams",
    ],
    conciergeUseCases: [
      "Weekend group fridge setups with breakfast, snacks, drinks, and hydration",
      "Morning-after essentials stocked before guests wake up to the first full day",
      "Celebration, dining, and transportation support through Bellhopt Concierge",
    ],
    arrivalBundle: [
      "Group weekend fridge and snack setup for short downtown stays",
      "Morning-after breakfast essentials with coffee, bakery, fruit, and quick protein",
      "Concierge-organized pantry starter for music-district and celebration travel",
    ],
    localFaq: [
      {
        q: "Why is Nashville pre-arrival grocery delivery valuable for short-term rentals?",
        a: "Many Nashville stays are short, group-oriented, and front-loaded around the first night. Bellhopt helps guests skip the grocery errand and walk into a stocked, organized home right away.",
      },
      {
        q: "Does Bellhopt work for downtown Nashville buildings with elevators and entry rules?",
        a: "Yes. We use the property's building instructions, elevator timing, and access notes to make sure the grocery stocking run fits the operational reality of the stay.",
      },
      {
        q: "Can Nashville guests order from a full shopping experience instead of a preset package?",
        a: "Yes. Bellhopt supports 20,000+ products so guests can build a true trip-specific grocery cart.",
      },
      {
        q: "Does Bellhopt offer concierge services beyond groceries in Nashville?",
        a: "Yes. Bellhopt can support a wider guest concierge experience, including select celebration, dining, wellness, and transportation requests.",
      },
      {
        q: "What lead time is required for Nashville Airbnb grocery delivery?",
        a: "A minimum 24-hour lead time is required so Bellhopt can execute the order cleanly before the guest arrives.",
      },
    ],
  },
  {
    city: "new-york",
    displayName: "New York City",
    indexable: true,
    metaDescription:
      "New York City Airbnb grocery delivery and pre-arrival grocery stocking by Bellhopt Concierge. Guests shop 20,000+ products, and Bellhopt delivers, stocks, and organizes before check-in. 24-hour lead time required.",
    heroIntro:
      "Bellhopt Concierge helps New York City short-term rentals offer pre-arrival grocery delivery that feels polished, fast, and operationally sound. Guests shop 20,000+ products, and Bellhopt stocks and organizes the home before they arrive so the stay starts cleanly.",
    marketWhy:
      "New York City execution depends on doorman procedures, elevator timing, delivery windows, and compact kitchen logistics. Grocery stocking in this market has to be precise, access-aware, and built for dense urban buildings.",
    operationsNotes:
      "Doorman policies, elevator timing, and delivery windows vary by building. Dense routing and strict access details are essential to keep arrivals on schedule and avoid failed handoffs.",
    howItWorksNotes: [
      "Property teams provide building rules, access notes, and arrival timing so Bellhopt can plan each run around New York City constraints.",
      "Guests choose from 20,000+ products and build a real grocery order that matches the trip, not a generic preset.",
      "Bellhopt shops, delivers, stocks, and organizes the order inside the home, then supports ongoing concierge requests when the stay needs more than groceries.",
    ],
    serviceHighlights: [
      "Pre-arrival grocery delivery built for dense urban short-term rental operations",
      "During-stay concierge services that strengthen the guest experience beyond the kitchen",
      "A high-touch but repeatable workflow for New York City property managers and host teams",
    ],
    conciergeUseCases: [
      "Compact-kitchen grocery stocking for apartment-based short-term rentals",
      "Quick-meal, breakfast, and coffee coverage for business and family stays",
      "Bellhopt Concierge support for dining, transport, celebration, and convenience requests",
    ],
    arrivalBundle: [
      "Compact-kitchen essentials for city apartments with breakfast, dairy, and pantry basics",
      "Premium quick-meal bundle for short business stays and late arrivals",
      "Family city-break setup with breakfast, snacks, fruit, and beverages",
    ],
    localFaq: [
      {
        q: "How does Bellhopt manage New York City Airbnb grocery delivery in doorman buildings?",
        a: "Bellhopt works from the building and property instructions provided by the host or manager, including doorman requirements, elevator timing, and accepted delivery windows.",
      },
      {
        q: "Is Bellhopt a door delivery service in New York City?",
        a: "No. Bellhopt is designed for stocked-and-organized execution inside the home when access is available, which creates a stronger arrival experience than door-only delivery.",
      },
      {
        q: "Can New York City guests order full-trip groceries through Bellhopt?",
        a: "Yes. Guests shop from 20,000+ products, which supports real trip planning rather than a limited convenience bundle.",
      },
      {
        q: "Do New York City property managers use Bellhopt across multiple listings?",
        a: "Yes. Bellhopt is built for repeatable portfolio operations and helps operators maintain a more consistent arrival standard across homes.",
      },
      {
        q: "What lead time is required for New York City grocery stocking?",
        a: "Bellhopt requires at least 24 hours of lead time so the order can be shopped, routed, and stocked reliably inside the property's access rules.",
      },
    ],
  },
  {
    city: "chicago",
    displayName: "Chicago",
    indexable: true,
    metaDescription:
      "Chicago Airbnb grocery delivery and pre-arrival grocery stocking by Bellhopt Concierge. Guests shop 20,000+ products, and Bellhopt delivers, stocks, and organizes before check-in. 24-hour lead time required.",
    heroIntro:
      "Bellhopt Concierge helps Chicago vacation rentals and short-term rentals create a better first hour with pre-arrival grocery delivery that is stocked and organized before check-in. Guests shop 20,000+ products, and Bellhopt handles the execution end to end.",
    marketWhy:
      "Chicago grocery stocking has to work across weather swings, mixed building types, and neighborhood-specific access conditions. Reliable execution starts with strong property notes and ends with an arrival-ready kitchen.",
    operationsNotes:
      "Weather variability and mixed inventory across neighborhoods require dependable planning and flexible packaging. Access reliability depends on complete entry details, timing discipline, and clean handoff instructions.",
    howItWorksNotes: [
      "Property teams provide access details, timing expectations, and turnover notes so Bellhopt can execute cleanly in Chicago's mixed building environment.",
      "Guests shop from 20,000+ products to build an order that fits the trip instead of defaulting to a limited essentials package.",
      "Bellhopt Concierge completes the shopping, delivery, stocking, and organization before check-in and can support guest concierge needs during the stay.",
    ],
    serviceHighlights: [
      "Pre-arrival grocery delivery that leaves Chicago stays stocked and organized",
      "During-stay concierge services that support both leisure and business travel patterns",
      "A repeatable guest-service system for Chicago property managers and operators",
    ],
    conciergeUseCases: [
      "Arrival-night meal coverage and breakfast setup for winter and shoulder-season stays",
      "Protein, produce, and pantry stocking for long-weekend group travel",
      "Concierge support for dining, transport, and celebration requests during the stay",
    ],
    arrivalBundle: [
      "Cold-weather comfort pantry starter with breakfast, soup-ready basics, and snacks",
      "Extended-weekend protein and produce kit for group and family stays",
      "Arrival-night ready-to-eat essentials with breakfast coverage for the next morning",
    ],
    localFaq: [
      {
        q: "What does Chicago Airbnb grocery delivery with Bellhopt include?",
        a: "Bellhopt shops the order, delivers it to the property, stocks the fridge and pantry, and organizes the kitchen before check-in. It is a stocked-and-organized service, not a curbside handoff.",
      },
      {
        q: "Can Bellhopt work with Chicago condos and residential buildings?",
        a: "Yes. We follow the building access notes, parking rules, and timing instructions provided by the host or property manager.",
      },
      {
        q: "Can Chicago guests order from a full grocery catalog?",
        a: "Yes. Bellhopt supports 20,000+ products so guests can order full-stay groceries that match the trip and household needs.",
      },
      {
        q: "Does Bellhopt offer concierge services beyond groceries in Chicago?",
        a: "Yes. Bellhopt can support additional guest concierge services in the market, which helps operators deliver a more premium stay experience.",
      },
      {
        q: "What lead time is required for Chicago grocery stocking?",
        a: "A minimum 24-hour lead time is required so Bellhopt can protect order quality and execute the arrival setup reliably.",
      },
    ],
  },
  {
    city: "seattle",
    displayName: "Seattle",
    indexable: true,
    metaDescription:
      "Seattle Airbnb grocery delivery and vacation rental grocery stocking by Bellhopt Concierge. Guests shop 20,000+ products, and Bellhopt delivers, stocks, and organizes before arrival. 24-hour lead time required.",
    heroIntro:
      "Bellhopt Concierge helps Seattle short-term rentals offer pre-arrival grocery delivery that feels curated and operationally dependable. Guests can shop 20,000+ products, and Bellhopt delivers, stocks, and organizes the home before the stay begins.",
    marketWhy:
      "Seattle inventory brings together hillside routing, variable parking, and guests who often want healthier groceries, coffee-forward baskets, and longer-stay practicality. Execution depends on access clarity and careful route planning.",
    operationsNotes:
      "Hillside neighborhoods and variable parking create route complexity. Guests often prioritize healthier staples, coffee-forward orders, and a kitchen that feels usable from the moment they check in.",
    howItWorksNotes: [
      "Hosts and managers provide the property access flow, parking notes, and arrival timing so Bellhopt can route Seattle orders correctly.",
      "Guests build a trip-specific grocery cart from 20,000+ products rather than choosing from a narrow essentials menu.",
      "Bellhopt shops, delivers, stocks, and organizes the home before arrival and can support concierge requests during the stay when needed.",
    ],
    serviceHighlights: [
      "Pre-arrival grocery delivery built for Seattle homes, condos, and longer stays",
      "During-stay concierge services that extend the guest experience beyond groceries",
      "A more reliable operating layer for Seattle property managers and portfolio teams",
    ],
    conciergeUseCases: [
      "Coffee-first arrival setups with breakfast, dairy, fruit, and pantry staples",
      "Fresh produce and healthy-fridge stocking for extended stays",
      "Concierge support for dining, transport, and special guest requests during the stay",
    ],
    arrivalBundle: [
      "Coffee-first arrival setup with breakfast essentials and bakery coverage",
      "Fresh produce and pantry reset for 5 to 7 night stays",
      "Rainy-day comfort bundle with snack, soup, breakfast, and easy-meal basics",
    ],
    localFaq: [
      {
        q: "How does Seattle Airbnb grocery delivery work with Bellhopt Concierge?",
        a: "Guests order ahead from 20,000+ products, and Bellhopt handles the shopping, delivery, stocking, and organization before check-in so the kitchen is ready from the start.",
      },
      {
        q: "Can Bellhopt support Seattle homes with tricky parking or hillside access?",
        a: "Yes. We work from the property's route and parking notes so the order can be delivered and stocked cleanly even when access requires extra planning.",
      },
      {
        q: "Can Seattle guests order healthier groceries and longer-stay essentials?",
        a: "Yes. The shopping flow supports a full grocery experience with 20,000+ products, which works well for wellness-focused carts, coffee-heavy baskets, and longer stays.",
      },
      {
        q: "Do Seattle property managers use Bellhopt as a concierge layer too?",
        a: "Yes. Bellhopt can support both pre-arrival grocery stocking and additional guest concierge services, which helps operators strengthen the overall stay experience.",
      },
      {
        q: "What lead time is required for Seattle pre-arrival grocery orders?",
        a: "At least 24 hours of lead time is required to protect reliability, shopping quality, and arrival timing.",
      },
    ],
  },
  {
    city: "denver",
    displayName: "Denver",
    indexable: true,
    metaDescription:
      "Denver Airbnb grocery delivery and pre-arrival grocery stocking by Bellhopt Concierge. Guests shop 20,000+ products, and Bellhopt delivers, stocks, and organizes vacation rentals before arrival. 24-hour lead time required.",
    heroIntro:
      "Bellhopt Concierge helps Denver short-term rentals offer a stronger arrival experience with pre-arrival grocery delivery that is fully stocked and organized before check-in. Guests shop 20,000+ products, and Bellhopt executes the order so the home feels ready right away.",
    marketWhy:
      "Denver arrivals often combine suburban homes, mountain-adjacent travel patterns, and guests who care about hydration, breakfast readiness, and longer-stay practicality. Grocery stocking has to be dependable, flexible, and built around property access details.",
    operationsNotes:
      "Denver execution often includes garage-entry homes, suburban routing, and staggered arrival windows shaped by flight timing and mountain travel. Clear access notes and a disciplined arrival workflow keep the order on track.",
    howItWorksNotes: [
      "Hosts and managers provide access notes, arrival timing, and property instructions so Bellhopt can route Denver orders accurately.",
      "Guests order from 20,000+ products, which supports full-trip grocery shopping instead of a thin essentials bundle.",
      "Bellhopt shops, delivers, stocks, and organizes the home before check-in and can support additional concierge requests during the stay.",
    ],
    serviceHighlights: [
      "Pre-arrival grocery delivery for Denver vacation rentals and short-term rentals",
      "During-stay concierge services that support mountain-adjacent leisure and city stays",
      "A repeatable arrival workflow for Denver property managers and host teams",
    ],
    conciergeUseCases: [
      "Hydration and breakfast setups for altitude-aware arrivals",
      "Longer-stay grocery stocking for family and remote-work travel",
      "Bellhopt Concierge support for dining, transport, and stay-specific service requests",
    ],
    arrivalBundle: [
      "Altitude-ready hydration bundle with water, electrolytes, fruit, and recovery snacks",
      "Denver breakfast starter with eggs, yogurt, coffee, fruit, and bakery staples",
      "Extended-stay fridge and pantry reset with produce, protein, dairy, and snacks",
    ],
    localFaq: [
      {
        q: "What does Denver Airbnb grocery delivery with Bellhopt include?",
        a: "Bellhopt provides pre-arrival grocery delivery that is stocked and organized inside the home. Guests order ahead, and we handle the shopping, delivery, and setup before check-in.",
      },
      {
        q: "Can Denver guests place a full grocery order through Bellhopt?",
        a: "Yes. Bellhopt supports 20,000+ products, so guests can create a full-trip grocery order instead of relying on a limited preset package.",
      },
      {
        q: "Does Bellhopt work for Denver property managers with multiple homes?",
        a: "Yes. Bellhopt is built for repeatable execution across short-term rental portfolios, which helps managers create a stronger and more consistent arrival standard.",
      },
      {
        q: "Does Bellhopt offer concierge services beyond groceries in Denver?",
        a: "Yes. Bellhopt can support additional guest concierge services in the market, helping operators offer a more complete hospitality layer during the stay.",
      },
      {
        q: "What lead time is required for Denver grocery stocking?",
        a: "A minimum 24-hour lead time is required so Bellhopt can execute the order accurately and leave the home arrival-ready.",
      },
    ],
  },
  {
    city: "charleston",
    displayName: "Charleston",
    indexable: true,
    metaDescription:
      "Charleston Airbnb grocery delivery and vacation rental grocery stocking by Bellhopt Concierge. Guests shop 20,000+ products, and Bellhopt delivers, stocks, and organizes before check-in. 24-hour lead time required.",
    heroIntro:
      "Bellhopt Concierge helps Charleston vacation rentals create a more premium arrival with pre-arrival grocery delivery that is stocked and organized before the guest walks in. Guests shop from 20,000+ products, and Bellhopt handles the operation end to end.",
    marketWhy:
      "Charleston travel mixes historic homes, walkable urban inventory, and coastal leisure demand where smooth arrivals matter. Grocery stocking works best when access details, parking notes, and timing are all operationally clear before dispatch.",
    operationsNotes:
      "Charleston properties often combine historic-home access quirks, limited parking, and tightly timed leisure arrivals. A clean grocery stocking run depends on complete entry instructions and well-timed dispatch before check-in.",
    howItWorksNotes: [
      "Hosts and property managers provide access instructions, timing notes, and property rules so Bellhopt can execute reliably across Charleston inventory.",
      "Guests shop from 20,000+ products and place a full pre-arrival grocery order that matches the trip and the group.",
      "Bellhopt shops, delivers, stocks, and organizes the order before arrival and can support concierge needs during the stay when the guest experience calls for more.",
    ],
    serviceHighlights: [
      "Pre-arrival grocery delivery for Charleston vacation rentals and short-term rentals",
      "During-stay concierge services that support higher-touch leisure travel",
      "A stronger guest-service layer for Charleston property managers who want a better first impression",
    ],
    conciergeUseCases: [
      "Welcome stocking for weekend leisure stays with breakfast, snacks, and hydration already in place",
      "Longer-stay pantry resets for family and group travel",
      "Bellhopt Concierge support for celebration details, dining, transport, and other guest requests",
    ],
    arrivalBundle: [
      "Charleston welcome bundle with breakfast staples, fruit, snacks, and hydration",
      "Weekend leisure pantry starter with bakery, dairy, produce, and ready-to-eat items",
      "Family stay grocery reset with breakfast coverage, drinks, and snack essentials",
    ],
    localFaq: [
      {
        q: "How does Charleston Airbnb grocery delivery work with Bellhopt?",
        a: "Guests order ahead from 20,000+ products, and Bellhopt handles the shopping, delivery, stocking, and organization before check-in. The goal is an arrival-ready kitchen, not a simple doorstep drop-off.",
      },
      {
        q: "Can Bellhopt work with Charleston homes that have unique access or parking instructions?",
        a: "Yes. We follow the property-specific instructions provided by the host or property manager so the grocery stocking run fits the home's access reality.",
      },
      {
        q: "Can Charleston guests order more than basic groceries?",
        a: "Yes. Bellhopt supports a full shopping experience with 20,000+ products, which gives guests far more choice than a preset essentials package.",
      },
      {
        q: "Do you offer concierge services beyond groceries in Charleston?",
        a: "Yes. Bellhopt can support additional concierge services during the stay, helping operators offer a stronger guest experience beyond pre-arrival grocery stocking.",
      },
      {
        q: "What lead time is required for Charleston grocery delivery and stocking?",
        a: "Bellhopt requires a minimum 24-hour lead time so the order can be executed cleanly and stocked before the guest arrives.",
      },
    ],
  },
];

export const defaultLocalFaq = (city) => [
  {
    q: `Do you only drop groceries at the door in ${city}?`,
    a: `No. Bellhopt Concierge is built for in-home stocking and organization in ${city} when property access is provided.`,
  },
  {
    q: `What lead time is required for ${city} orders?`,
    a: "A minimum 24-hour lead time is required to protect quality and dispatch reliability.",
  },
  {
    q: `Can this work across multiple short-term rentals in ${city}?`,
    a: `Yes. The workflow is designed for multi-property operators in ${city}, including enterprise portfolios.`,
  },
  {
    q: `How are substitutions handled in ${city}?`,
    a: "We follow available substitution preferences and choose guest-friendly alternatives when needed.",
  },
  {
    q: `Do you support alcohol stocking in ${city}?`,
    a: "If permitted, alcohol handling follows local rules and each property's policy requirements.",
  },
  {
    q: `Is Bellhopt affiliated with Airbnb in ${city}?`,
    a: "No. Bellhopt is an independent service built for short-term rentals and is not affiliated with Airbnb.",
  },
];
